// extracted by mini-css-extract-plugin
export default {"cls1":"Edj3DaggYWO2Hq_zT5EA","cls2":"jEf3TDUyEaRNqtiVEYEC Edj3DaggYWO2Hq_zT5EA","isInvalid":"wdKQFuivLttrMW8qTX3P","isEditMode":"p5eqOMDmbbm3_T7HmsQA"};